import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeamsLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7333 9.68359H22.9253C23.5103 9.68359 23.9846 10.1626 23.9846 10.7534V16.4499C23.9846 18.6214 22.2416 20.3818 20.0916 20.3818H20.0732C17.9232 20.3821 16.18 18.622 16.1797 16.4505V10.2427C16.1797 9.93392 16.4275 9.68359 16.7333 9.68359Z",
			fill: "#5059C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9189 8.55975C22.3044 8.55975 23.4276 7.42534 23.4276 6.02597C23.4276 4.6266 22.3044 3.49219 20.9189 3.49219C19.5333 3.49219 18.4102 4.6266 18.4102 6.02597C18.4102 7.42534 19.5333 8.55975 20.9189 8.55975Z",
			fill: "#5059C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1159 8.5581C15.1172 8.5581 16.7396 6.91951 16.7396 4.89819C16.7396 2.87688 15.1172 1.23828 13.1159 1.23828C11.1146 1.23828 9.49219 2.87688 9.49219 4.89819C9.49219 6.91951 11.1146 8.5581 13.1159 8.5581Z",
			fill: "#7B83EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9478 9.68359H7.72674C7.14871 9.69804 6.69145 10.1825 6.70486 10.7664V17.2636C6.62414 20.7671 9.36852 23.6744 12.8373 23.7602C16.306 23.6744 19.0504 20.7671 18.9697 17.2636V10.7664C18.9831 10.1825 18.5258 9.69804 17.9478 9.68359Z",
			fill: "#7B83EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M13.3933 9.68359V18.7883C13.3905 19.2058 13.14 19.5809 12.7578 19.7399C12.6361 19.7919 12.5053 19.8187 12.3731 19.8187H7.19401C7.12154 19.6329 7.05464 19.4471 6.99889 19.2557C6.80374 18.6096 6.70417 17.9379 6.70341 17.2624V10.7647C6.69001 10.1818 7.14652 9.69804 7.72362 9.68359H13.3933Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.8358 9.68359V19.3514C12.8358 19.4849 12.8093 19.617 12.7578 19.7399C12.6004 20.126 12.229 20.379 11.8156 20.3818H7.45604C7.36126 20.196 7.27206 20.0102 7.19401 19.8187C7.11596 19.6273 7.05464 19.4471 6.99889 19.2557C6.80373 18.6096 6.70417 17.9379 6.70341 17.2624V10.7647C6.69001 10.1818 7.14652 9.69804 7.72362 9.68359H12.8358Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.8358 9.68359V18.2253C12.8316 18.7926 12.3773 19.2514 11.8156 19.2557H6.99889C6.80373 18.6096 6.70417 17.9379 6.70341 17.2624V10.7647C6.69001 10.1818 7.14652 9.69804 7.72362 9.68359H12.8358Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.2783 9.68359V18.2253C12.2741 18.7926 11.8198 19.2514 11.2581 19.2557H6.99889C6.80373 18.6096 6.70417 17.9379 6.70341 17.2624V10.7647C6.69001 10.1818 7.14652 9.69804 7.72362 9.68359H12.2783Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M13.3919 6.77258V8.54623C13.2972 8.55186 13.208 8.55749 13.1132 8.55749C13.0184 8.55749 12.9292 8.55187 12.8344 8.54623C12.6463 8.53362 12.4596 8.50346 12.277 8.45614C11.148 8.18612 10.2154 7.38648 9.76824 6.30525C9.69132 6.12367 9.63158 5.93514 9.58984 5.74219H12.3717C12.9343 5.74434 13.3898 6.2044 13.3919 6.77258Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.8357 7.33508V8.54567C12.6475 8.53306 12.4609 8.5029 12.2782 8.45558C11.1493 8.18556 10.2166 7.38592 9.76953 6.30469H11.8155C12.3781 6.30684 12.8336 6.76691 12.8357 7.33508Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.8357 7.33508V8.54567C12.6475 8.53306 12.4609 8.5029 12.2782 8.45558C11.1493 8.18556 10.2166 7.38592 9.76953 6.30469H11.8155C12.3781 6.30684 12.8336 6.76691 12.8357 7.33508Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M12.2782 7.33509V8.45558C11.1493 8.18556 10.2166 7.38592 9.76953 6.30469H11.258C11.8206 6.30685 12.2761 6.76692 12.2782 7.33509Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.0375 6.30469H11.2585C11.8229 6.30469 12.2804 6.76678 12.2804 7.33678V17.66C12.2804 18.23 11.8229 18.6921 11.2585 18.6921H1.0375C0.47313 18.6921 0.015625 18.23 0.015625 17.66V7.33678C0.015625 6.76678 0.473141 6.30469 1.0375 6.30469Z",
			fill: "url(#paint0_linear_198_11351)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83571 10.2346H6.79249V15.854H5.49076V10.2346H3.45703V9.14453H8.83571V10.2346Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_198_11351",
			x1: 2.14627,
			y1: 5.49822,
			x2: 10.2698,
			y2: 19.4286,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#5A62C3" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#4D55BD"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3940AB"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgTeamsLogo);
export { ForwardRef as ReactComponent };
